import { render, staticRenderFns } from "./OrganizationDetailsForm.vue?vue&type=template&id=93871eec&"
import script from "./OrganizationDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports